import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  Tooltip,
} from '@folio/stripes/components';

import {
  ICON_TRANSLATION_KEY_NAME,
} from '../../../constants';
import ActionButton from '../action-button';

const ActionButtonWithTooltip = ({
  icon,
  index,
  onClickHandler,
}) => {
  return (
    <Tooltip
      id={`${ICON_TRANSLATION_KEY_NAME[icon]}-${index}`}
      text={<FormattedMessage id={`ui-task-list.tooltip.${ICON_TRANSLATION_KEY_NAME[icon]}`} />}
    >
      {
        ({ ref, ariaIds }) => (
          <div
            ref={ref}
            aria-labelledby={ariaIds.text}
          >
            <ActionButton
              icon={icon}
              onClickHandler={onClickHandler}
            />
          </div>
        )
      }
    </Tooltip>
  );
};

ActionButtonWithTooltip.propTypes = {
  icon: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onClickHandler: PropTypes.func.isRequired,
};

export default ActionButtonWithTooltip;
